/**
 * used to get Formulary info for found drug.
 */
export class FormularySearchRequest {
    public WebRegionId!: number;
    public DrugName!: string;
}
